"use strict";

jQuery(document).ready(function ($) {
  $(window).on("load resize", function (e) {
    if ($(window).width() < 1100) {
      $('.info-list').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: '.home-slider-next-arrow',
        responsive: [{
          breakpoint: 840,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 540,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    } else {
      $('.info-list').slick('unslick');
    }
  }); // Check is mobile screen resloution

  var isMobileRes = false;

  if (window.matchMedia("(min-width: 767px)").matches) {
    isMobileRes = true;
  } // Change next-btn color if first slide has class Style-1


  $('.slider-items').on('init', function (event, slick) {
    var firstSlide = $('.slick-current');

    if (firstSlide.hasClass('style-1')) {
      $('.slick-next').addClass('red');
    }
  });
  / Slick slider Testimonails on main page /;
  var mainSlider = $('.slider-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: false,
    focusOnSelect: true,
    variableWidth: true,
    arrows: true,
    autoplay: isMobileRes,
    // autoplay: false,
    autoplaySpeed: 5000,
    speed: 0
  });
  / Mobile Slick slider Testimonails/;
  $('.slider-mobile-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: isMobileRes,
    autoplaySpeed: 5000
  }); // Slider revers animation

  var sliderElement = $('.slider-items');
  mainSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var CurrentSlideDom = $(slick.$slides.get(nextSlide));
    var direction = null;

    if (Math.abs(nextSlide - currentSlide) == 1) {
      direction = nextSlide - currentSlide > 0 ? "right" : "left";
    } else {
      direction = nextSlide - currentSlide > 0 ? "left" : "right";
    }

    if (direction == 'left') {
      sliderElement.addClass('revers-animation');
    } else if (direction == 'right') {
      sliderElement.removeClass('revers-animation');
    } // Change next-btn color for Style-1 active slides


    if (CurrentSlideDom.hasClass('style-1')) {
      $('.slick-next').addClass('red');
    } else {
      $('.slick-next').removeClass('red');
    }
  }); // Show and hidden main menu

  $('.menu-btn').on("click", function () {
    $(this).toggleClass('opened');

    if ($('.menu-btn').hasClass("opened")) {
      $('.menu-btn').html('close');
    } else {
      $('.menu-btn').html('menu');
    }

    $(".main-navigation").toggleClass("visible");

    if ($(".main-navigation").hasClass("visible")) {
      $(".cd-panel").addClass("is-visible");
      $("body").addClass("menu-visible");
    } else {
      $(".cd-panel").removeClass("is-visible");
      $("body").removeClass("menu-visible");
    }
  }); // Onclick main menu item hide menu

  $('#myNav a').click(function () {
    $('.menu-btn').toggleClass('opened');
    $('.menu-btn').html('menu');
    $(".main-navigation").toggleClass("visible");
    $(".cd-panel").removeClass("is-visible");
    $("body").removeClass("menu-visible");
  });
  $('.cd-panel').on('click', function (event) {
    if ($(event.target).is('.cd-panel')) {
      $('.cd-panel').removeClass('is-visible');
    }
  }); // Helper function - Fixed header on page scroll

  var $nav = $('.contact-menu');
  var $headerLogo = $('.logo');
  var $win = $(window);
  var winH = $win.height();

  function fixedScroll() {
    if ($win.scrollTop() > winH) {
      $nav.addClass("on_top");
      $headerLogo.addClass("logo-fixed");

      if ($(".contact-menu").hasClass("on_top")) {
        $("body").addClass("header-btn");
      }
    } else {
      $nav.removeClass("on_top");
      $headerLogo.removeClass("logo-fixed");

      if ($("ul").hasClass("contact-menu")) {
        $("body").removeClass("header-btn");
      }
    }
  } // Detect landscape screens


  function isLandscapeScreen() {
    if (window.matchMedia("(orientation: landscape)").matches && $(window).innerWidth() < 1000 && $(window).innerHeight() < 420) {
      return true;
    } else {
      return false;
    }
  } // Fixed header on scroll page


  $win.on("scroll", function () {
    if ($(this).scrollTop() > winH || $("body").hasClass("not-front") || $win.width() < 768 || isLandscapeScreen()) {
      $nav.addClass("on_top");
      $headerLogo.addClass("logo-fixed");

      if ($(".contact-menu").hasClass("on_top")) {
        $("body").addClass("header-btn");
      }
    } else {
      $nav.removeClass("on_top");
      $headerLogo.removeClass("logo-fixed");

      if ($("ul").hasClass("contact-menu")) {
        $("body").removeClass("header-btn");
      }
    }
  }).on("resize", function () {
    winH = $(this).height();
  }); // Helper function - Landscape add class

  function landscape() {
    var $navigation = $('.contact-menu');

    if ($("body").hasClass("not-front") || $win.width() < 768 || isLandscapeScreen()) {
      $navigation.addClass("on_top");
      $("body").addClass("header-btn");
    } else {
      $navigation.removeClass("on_top");
      $("body").removeClass("header-btn");
    }
  }

  landscape();
  $(window).on("orientationchange", function (event) {
    landscape();
    resizeBlueBox();
  }); // Input Mask for form phone field

  $('.tel').on('input', function () {
    $(this).val($(this).val().replace(/[A-Za-zА-Яа-яЁё]/, ''));
  }); //initial display - page width

  var basicWidth = 1294;
  resizeBlueBox();
  getAspectRatio(); //show width as we resize

  $(window).resize(function () {
    resizeBlueBox();
    getAspectRatio();
  });

  function resizeBlueBox() {
    var logoWidth = $('.logo').width();
    var sideHeaderWidth = $('.side-header').width();
    var blueBox = $('.teal-box');
    var heroBox = $('.hero-img');
    var contactMenu = $('.contact-menu');
    var sumMenu = logoWidth + sideHeaderWidth + 1;
    var newWidthHero = $("body").prop("scrollWidth") - sumMenu + 22;
    contactMenu.width(newWidthHero);

    if ($(window).innerWidth() > 768 && !isLandscapeScreen()) {
      heroBox.width(newWidthHero);
      blueBox.width(sumMenu);
    } else {
      heroBox.width('100%');
      blueBox.width(0);
    }
  } // Helper function - Add body class on 4:3 screens


  function getAspectRatio() {
    var ratio = $(window).innerWidth() / $(window).innerHeight();

    if (ratio <= 1.34) {
      $('body').addClass('responsive-side');
    } else {
      $('body').removeClass('responsive-side');
    }
  } // Hide CF7 submit notifications


  $('.wpcf7-submit').on('click', function (e) {
    $('.wpcf7-response-output').show();
    setTimeout(function () {
      $('.wpcf7-response-output').hide('slow');
    }, 7000);
  }); // Redirect to service page on submit Start Now form

  document.addEventListener('wpcf7mailsent', function (event) {
    if (event.detail.contactFormId == '422') {
      setTimeout(function () {
        location = js_variables.site_url + '/services';
      }, 5000);
    }
  }, false); // Disabled phone links on tablet and PC

  var isMobile = {
    Android: function Android() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
  }; // Disabled footer phone links on PC

  if (!isMobile.any()) {
    $('.footer-tel a, .contacts-tel a').removeAttr("href");
    $('.footer-tel a, .contacts-tel a').addClass('not-link');
  }

  var is_safari = navigator.platform.indexOf("Mac") === 0 || navigator.platform === "iPhone";

  if (is_safari) {
    $("body").addClass("safari-ios");
  } // Fixed header if not front page


  if ($("body").hasClass("not-front") || $win.width() < 768) {
    $("body").addClass("header-btn");
    $(".logo").addClass("logo-fixed");
    $('.contact-menu').addClass("on_top");
  } else {
    fixedScroll();
  } // Scroll slider Start
  // init controller


  var controller = new ScrollMagic.Controller();
  var leftSlider = $('.magic-wrapper__left .magic-content-wrapper');
  var countLeftSlides = leftSlider.children().length;
  var rightSlider = $('.magic-wrapper__right .magic-content-wrapper');
  var countRightSlides = rightSlider.children().length;
  var paddingDuration = 200 * countLeftSlides; // Fixed scroll slider

  new ScrollMagic.Scene({
    duration: paddingDuration,
    // the scene should last for a scroll distance of 100px
    triggerElement: '.section-magic__inner',
    triggerHook: 0
  }).setPin('.section-magic__inner') // pins the element for the the scene's duration
  .addTo(controller); // assign the scene to the controller
  // Change transform scroll slides 

  new ScrollMagic.Scene({
    duration: 900,
    triggerElement: '.section-magic__inner',
    triggerHook: 0
  }).on("progress", function (event) {
    var procentege = event.progress * 100;

    for (var i = 0; i <= countLeftSlides - 1; i++) {
      var slideSelector = ".magiccontent" + i;
      var initPosition = 0;

      if (i > 0) {
        initPosition = i * 100;
      }

      var currentSlidePosition = initPosition - procentege.toFixed(2) * countLeftSlides;

      if (i == 0) {
        $(slideSelector).css({
          transform: 'translate(0, -' + currentSlidePosition + '%)'
        });
      }

      $(slideSelector).css({
        transform: 'translate(0, ' + currentSlidePosition + '%)'
      });

      if (i == countLeftSlides - 1 && currentSlidePosition < 0.2) {
        $(slideSelector).css({
          transform: 'translate(0, 0)'
        });
      }
    } // Reverse


    for (var _i = 0; _i <= countRightSlides - 1; _i++) {
      var slideSelector = ".magiccontentrevers" + _i;
      var initPosition = 0;

      if (_i > 0) {
        initPosition = _i * 100;
      }

      var currentSlidePosition = initPosition - procentege.toFixed(2) * countRightSlides;

      if (_i == 0) {
        $(slideSelector).css({
          transform: 'translate(0, ' + procentege.toFixed(2) * countRightSlides + '%)'
        });
      }

      if (_i > 0 && _i <= countRightSlides - 1) {
        if (currentSlidePosition > 0) {
          $(slideSelector).css({
            transform: 'translate(0, -' + currentSlidePosition + '%)'
          });
        } else {
          $(slideSelector).css({
            transform: 'translate(0, ' + Math.abs(currentSlidePosition) + '%)'
          });
        }
      }

      if (_i == countRightSlides - 1 && currentSlidePosition < 0.2) {
        $(slideSelector).css({
          transform: 'translate(0, 0)'
        });
      }
    }
  }).addTo(controller); // AJAX loading more posts on Market Analysis page

  $('.loadmore-posts').click(function () {
    var button = $('.loadmore-posts'),
        post_type = $(this).attr("data-type"),
        max_page = $(this).attr("data-max-page"),
        current_page = $(this).attr("data-page"),
        sendData = {
      'action': 'loadmore_posts',
      'page': current_page,
      'post_type': post_type
    };
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: sendData,
      type: 'POST',
      beforeSend: function beforeSend(xhr) {
        button.text('Loading...');
      },
      success: function success(data) {
        if (data) {
          button.text('Load More').before(data);
          button.data('page', sendData.page++);
          if (sendData.page == max_page) button.remove();
        } else {
          button.remove();
        }
      }
    });
  }); // Contact forms revalidate on typing empty field

  $(".wpcf7-form").on("keypress", '.wpcf7-not-valid', function () {
    if ($(this).val() !== null || $(this).val() !== undefined) {
      $(this).removeClass('wpcf7-not-valid');
    }
  }); // Check if body height is higher than window height :)

  if ($("body").height() > $(window).height()) {
    $("body").addClass("has-scrollbar");
  } else {
    $("body").removeClass("has-scrollbar");
  } // Check pre-content section in service page temlate


  if ($("body").hasClass('page-template-services-single-page') && !$(".wp-block-columns").hasClass("pre-content")) {
    $(".wave-block").addClass("without-pre-content");
    $(".service-content").addClass("without-pre-content");
  }
});